import { SphereIconButton } from "@components/common/sphere-icon-button";
import { SphereTooltip } from "@components/common/sphere-tooltip";
import { BaseProjectProps } from "@custom-types/project-types";
import { ShareLinkIcon } from "@flat-ui";
import { ProjectShareDialog } from "@pages/projects/project-share-dialog";
import { ProjectEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useState } from "react";

interface Props extends BaseProjectProps {
  /** Location where the component is used */
  location: "project-overview-page";
}

/** Renders share project button that wraps with project share dialog */
export function ShareProjectButton({ project, location }: Props): JSX.Element {
  const { trackEvent } = useTrackEvent();
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

  function onClick(): void {
    setIsDialogOpen(true);

    trackEvent({
      name: ProjectEvents.openShareProject,
      props: {
        projectId: project.id,
        location,
      },
    });
  }

  return (
    <ProjectShareDialog
      project={project}
      isOpen={isDialogOpen}
      onClose={() => setIsDialogOpen(false)}
    >
      <SphereTooltip
        title="Share project"
        boxProps={{
          sx: {},
        }}
      >
        <SphereIconButton component={ShareLinkIcon} onClick={onClick} />
      </SphereTooltip>
    </ProjectShareDialog>
  );
}
